import Cookies from "js-cookie";

const removeCsrfToken = () => {
    Cookies.remove("XSRF-TOKEN");
}

const getToken = (): string | undefined  => {
    return Cookies.get("authTokenMHP");
}

const setToken = (token: string) => {
    Cookies.set("authTokenMHP", token);
}

const removeToken = () => {
    Cookies.remove("authTokenMHP");
}

const getTokenTmp = (): string | undefined  => {
    return Cookies.get("authTokenMHPTmp");
}

const setTokenTmp = (token: string) => {
    Cookies.set("authTokenMHPTmp", token);
}

const removeTokenTmp = () => {
    Cookies.remove("authTokenMHPTmp");
}

const recordToken = () => {
    removeToken();

    if (getTokenTmp()) {
        setToken(<string>(getTokenTmp()));
    }

    removeTokenTmp()
}

export {
    getToken,
    setToken,
    removeToken,
    getTokenTmp,
    setTokenTmp,
    removeTokenTmp,
    removeCsrfToken,
    recordToken
}
